import React, { Component } from "react";
import Table from "../common/Table";

export default class PaymentTransactionHistoryTicket extends Component {
  constructor(props) {
    super(props);
    this.state = {
      client_id: this.props.match.params.id,
      histories: [],
      searchConditions: {},
      lastPage: 1,
      currentPage: 1,
      from: "",
      to: "",
      total: "",
    };
    this.handleSearch = this.handleSearch.bind(this);
  }

  componentWillMount() {
    const keySearch_str = this.props.location.search.substring(1);
    let keySearch_arr = { page: 1 };
    if (keySearch_str) {
      keySearch_arr = JSON.parse(
        '{"' +
          decodeURI(keySearch_str.replace(/&/g, '","').replace(/=/g, '":"')) +
          '"}'
      );
    }

    axios
      .post(
        `/api/payment-transaction-histories/${this.state.client_id}`,
        keySearch_arr
      )
      .then((response) => {
        this.setState({
          histories: response.data.data,
          lastPage: response.data.last_page,
          currentPage: response.data.current_page,
          searchConditions: keySearch_arr,
          from: response.data.from,
          to: response.data.to,
          total: response.data.total,
        });
        this.props.history.push({
          search: keySearch_str,
        });
      });
  }

  handleSearch(key) {
    this.setState({ searchConditions: key });

    axios
      .post(`/api/payment-transaction-histories/${this.state.client_id}`, key)
      .then((response) => {
        this.setState({
          histories: response.data.data,
          lastPage: response.data.last_page,
          currentPage: response.data.current_page,
          from: response.data.from,
          to: response.data.to,
          total: response.data.total,
        });
        this.props.history.push({
          search: $.param(key),
        });
      });
  }

  render() {
    const columns = [
      { name: "created_at", title: "日付", isSort: 0, type: "text" },
      {
        name: "order_id",
        title: "注文番号",
        isSort: 0,
        type: "text",
      },
    ];
    return (
      <React.Fragment>
        <div className="row">
          <div className="col-sm-12">
            <nav aria-label="breadcrumb">
              <ol className="breadcrumb mb-0">
                <li className="breadcrumb-item">
                  <a href="/home">ダッシュボード</a>
                </li>
                <li className="breadcrumb-item">
                  <a href="/ticketrequests">チケット申込み一覧</a>
                </li>
                <li className="breadcrumb-item active" aria-current="page">
                  クレジット決済履歴一覧
                </li>
              </ol>
            </nav>
          </div>
        </div>
        <main id="main">
          <div className="row">
            <div className="col-sm-12">
              <div className="card">
                <div className="card-body">
                  <div className="row">
                    <div className="col">
                      <h4 className="mt-2 mb-0 page-title">
                        クレジット決済履歴一覧
                      </h4>
                    </div>
                  </div>
                </div>
                <Table
                  onSearch={this.handleSearch}
                  data={this.state.histories}
                  header={columns}
                  myPagination={1}
                  searchConditions={this.state.searchConditions}
                  lastPage={this.state.lastPage}
                  currentPage={this.state.currentPage}
                  from={this.state.from}
                  to={this.state.to}
                  total={this.state.total}
                />
              </div>
            </div>
          </div>
        </main>
      </React.Fragment>
    );
  }
}
